module.exports = __webpack_public_path__ + "img/0-sm.fc96e2fb.jpg";